module.exports = __webpack_public_path__ + "img/logo.78fd8119.png";